import { _ } from "../../../../core/polyglot/polyglot.js";
import AccessRight from "./AccessRight.js";

let instance;

/**
 * TODO: write documentation
 */
export default class NoAccessRight extends AccessRight {
	getLabel() {
		return _("None");
	}

	static getType() {
		return "None";
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
